
namespace TabAurous.Retail {
    export class ProductWiseSalesOptions {
        items: POSSalesItemsRow[];
    }

    export class ProductWiseSalesPanel extends Serenity.TemplatedPanel<ProductWiseSalesOptions> {
        constructor(container: JQuery, opt: ProductWiseSalesOptions) {
            super(container, opt);
            

            //Grouping
            var items = this.options.items;

            var name= 'P1';
             var data= [1,2,3];
            
            var namearray = [name];
            var dataarray = [data];
            namearray.pop();
            dataarray.pop();
            for (var i = 0; i < items.length; i++) {
                var exists = false;
                for (var k = 0; k < namearray.length; k++) {
                    if (items[i].CategoryName == namearray[k]) {
                        dataarray[k][0] += items[i].M1Pieces;
                        dataarray[k][1] += items[i].M2Pieces;
                        dataarray[k][2] += items[i].M3Pieces;
                        dataarray[k][3] += items[i].M4Pieces;
                        dataarray[k][4] += items[i].M5Pieces;
                        dataarray[k][5] += items[i].M6Pieces;
                        dataarray[k][6] += items[i].M7Pieces;
                        dataarray[k][7] += items[i].M8Pieces;
                        dataarray[k][8] += items[i].M9Pieces;
                        dataarray[k][9] += items[i].M10Pieces;
                        dataarray[k][10] += items[i].M11Pieces;
                        dataarray[k][11] += items[i].M12Pieces;
                        exists = true;
                    }
                }
                if (!exists) {
                    namearray.push(items[i].CategoryName);
                    var newdata = [items[i].M1Pieces, items[i].M2Pieces, items[i].M3Pieces, items[i].M4Pieces, items[i].M5Pieces, items[i].M6Pieces,
                        items[i].M7Pieces, items[i].M8Pieces, items[i].M9Pieces, items[i].M10Pieces, items[i].M11Pieces, items[i].M12Pieces];
                    dataarray.push(newdata);
                }
            }
            var ser = [{ name, data }];
            ser.pop();
            for (var i = 0; i < namearray.length; i++) {
                name = namearray[i];
                data = dataarray[i];
                var newseries = { name, data };
                ser.push(newseries);
            }

            var options = {
                series: ser,
                chart: {
                    fontFamily: '"PT Sans", sans-serif',
                    type: 'bar',
                    height: 250,
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                xaxis: {
                   
                    categories: ['January','February','March','April','May','June','July','August','September','October','November','December'
                    ],
                },
                legend: {
                    position: 'right',
                    offsetY: 40
                },
                fill: {
                    opacity: 1
                }
            };




            //var x = document.getElementById('TabAurous_Reports_ChartPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }



    @Serenity.Decorators.registerClass()
    export class ProductWiseSalesGrid extends Serenity.EntityGrid<POSSalesItemsRow, any> {
        protected getColumnsKey() { return 'Retail.ProductWiseSales'; }
        protected getDialogType() { return POSSalesItemsDialog; }
        protected getIdProperty() { return POSSalesItemsRow.idProperty; }
        protected getInsertPermission() { return POSSalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesItemsRow.localTextPrefix; }
        protected getService() { return ProductWiseSalesService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: ProductWiseSalesPanel;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            //  this.addDateRangeFilter("TransDate", "Date");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();


            var plugin = new Slick.ColumnGroup();
            grid.registerPlugin(plugin);

            var columns = grid.getColumns();

            //grid.registerPlugin(new Slick.columng);

            for (let col of columns) {
                //console.log(col);
                if (col.field == "ProductCode" || col.field == "ProductTypeName") col.groupName = "Details";

                if (col.field == "M1Pieces" || col.field == "M1Amount") col.groupName = "January";
                if (col.field == "M2Pieces" || col.field == "M2Amount") col.groupName = "February";
                if (col.field == "M3Pieces" || col.field == "M3Amount") col.groupName = "March";
                if (col.field == "M4Pieces" || col.field == "M4Amount") col.groupName = "April";
                if (col.field == "M5Pieces" || col.field == "M5Amount") col.groupName = "May";
                if (col.field == "M6Pieces" || col.field == "M6Amount") col.groupName = "June";
                if (col.field == "M7Pieces" || col.field == "M7Amount") col.groupName = "July";
                if (col.field == "M8Pieces" || col.field == "M8Amount") col.groupName = "August";
                if (col.field == "M9Pieces" || col.field == "M9Amount") col.groupName = "September";
                if (col.field == "M10Pieces" || col.field == "M10Amount") col.groupName = "October";
                if (col.field == "M11Pieces" || col.field == "M11Amount") col.groupName = "November";
                if (col.field == "M12Pieces" || col.field == "M12Amount") col.groupName = "December";
            }

            plugin.enableColumnGrouping();

            grid.setColumns(columns);
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('M1Pieces'),
                    new Slick.Aggregators.Sum('M2Pieces'),
                    new Slick.Aggregators.Sum('M3Pieces'),
                    new Slick.Aggregators.Sum('M4Pieces'),
                    new Slick.Aggregators.Sum('M5Pieces'),
                    new Slick.Aggregators.Sum('M6Pieces'),
                    new Slick.Aggregators.Sum('M7Pieces'),
                    new Slick.Aggregators.Sum('M8Pieces'),
                    new Slick.Aggregators.Sum('M9Pieces'),
                    new Slick.Aggregators.Sum('M10Pieces'),
                    new Slick.Aggregators.Sum('M11Pieces'),
                    new Slick.Aggregators.Sum('M12Pieces'),
                    new Slick.Aggregators.Sum('M1Amount'),
                    new Slick.Aggregators.Sum('M2Amount'),
                    new Slick.Aggregators.Sum('M3Amount'),
                    new Slick.Aggregators.Sum('M4Amount'),
                    new Slick.Aggregators.Sum('M5Amount'),
                    new Slick.Aggregators.Sum('M6Amount'),
                    new Slick.Aggregators.Sum('M7Amount'),
                    new Slick.Aggregators.Sum('M8Amount'),
                    new Slick.Aggregators.Sum('M9Amount'),
                    new Slick.Aggregators.Sum('M10Amount'),
                    new Slick.Aggregators.Sum('M11Amount'),
                    new Slick.Aggregators.Sum('M12Amount')]
            });


            this.view.setGrouping([{
                formatter: g => {
                    return "<span class='slick-group-title-header'>" +
                        g.value +
                        "<span class='slick-cell l2 r2'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Pieces + "</span></span>" +
                        "<span class='slick-cell l3 r3'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Amount.toFixed(2) + "</span></span>" +
                        "<span class='slick-cell l4 r4'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Pieces + "</span></span>" +
                        "<span class='slick-cell l5 r5'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Amount.toFixed(2) + "</span></span>" +
                        "<span class='slick-cell l6 r6'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Pieces + "</span></span>" +
                        "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Amount.toFixed(2)+ "</span></span>" +
                        "<span class='slick-cell l8 r8'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Pieces + "</span></span>" +
                        "<span class='slick-cell l9 r9'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Amount.toFixed(2)+ "</span></span>" +
                        "<span class='slick-cell l10 r10'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Pieces + "</span></span>" +
                        "<span class='slick-cell l11 r11'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Amount.toFixed(2)+ "</span></span>" +
                        "<span class='slick-cell l12 r12'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Pieces + "</span></span>" +
                        "<span class='slick-cell l13 r13'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Amount.toFixed(2) + "</span></span>" +
                        "<span class='slick-cell l14 r14'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Pieces + "</span></span>" +
                        "<span class='slick-cell l15 r15'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Amount.toFixed(2) + "</span></span>" +
                        "<span class='slick-cell l16 r16'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Pieces + "</span></span>" +
                        "<span class='slick-cell l17 r17'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Amount.toFixed(2) + "</span></span>" +
                        "<span class='slick-cell l18 r18'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Pieces + "</span></span>" +
                        "<span class='slick-cell l19 r19'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Amount.toFixed(2) + "</span></span>" +
                        "<span class='slick-cell l20 r20'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Pieces + "</span></span>" +
                        "<span class='slick-cell l21 r21'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Amount.toFixed(2) + "</span></span>" +
                        "<span class='slick-cell l22 r22'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Pieces + "</span></span>" +
                        "<span class='slick-cell l23 r23'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Amount.toFixed(2) + "</span></span>" +
                        "<span class='slick-cell l24 r24'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Pieces + "</span></span>" +
                        "<span class='slick-cell l25 r25'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Amount.toFixed(2) + "</span></span>";
                },
                getter: 'ProductTypeName',
                displayTotalsRow: false,
            }, {
                    formatter: g => {
                        return "<span class='slick-group-title-header'>" +
                            g.value +
                            "<span class='slick-cell l2 r2'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Pieces + "</span></span>" +
                            "<span class='slick-cell l3 r3'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l4 r4'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Pieces + "</span></span>" +
                            "<span class='slick-cell l5 r5'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l6 r6'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Pieces + "</span></span>" +
                            "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l8 r8'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Pieces + "</span></span>" +
                            "<span class='slick-cell l9 r9'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l10 r10'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Pieces + "</span></span>" +
                            "<span class='slick-cell l11 r11'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l12 r12'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Pieces + "</span></span>" +
                            "<span class='slick-cell l13 r13'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l14 r14'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Pieces + "</span></span>" +
                            "<span class='slick-cell l15 r15'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l16 r16'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Pieces + "</span></span>" +
                            "<span class='slick-cell l17 r17'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l18 r18'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Pieces + "</span></span>" +
                            "<span class='slick-cell l19 r19'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l20 r20'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Pieces + "</span></span>" +
                            "<span class='slick-cell l21 r21'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l22 r22'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Pieces + "</span></span>" +
                            "<span class='slick-cell l23 r23'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l24 r24'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Pieces + "</span></span>" +
                            "<span class='slick-cell l25 r25'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Amount.toFixed(2) + "</span></span>";
                    },
                getter: 'TypeName',
                displayTotalsRow: false

            }, {
                    formatter: g => {
                        return "<span class='slick-group-title-header'>" +
                            g.value +
                            "<span class='slick-cell l2 r2'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Pieces + "</span></span>" +
                            "<span class='slick-cell l3 r3'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M1Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l4 r4'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Pieces + "</span></span>" +
                            "<span class='slick-cell l5 r5'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M2Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l6 r6'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Pieces + "</span></span>" +
                            "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M3Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l8 r8'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Pieces + "</span></span>" +
                            "<span class='slick-cell l9 r9'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M4Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l10 r10'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Pieces + "</span></span>" +
                            "<span class='slick-cell l11 r11'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M5Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l12 r12'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Pieces + "</span></span>" +
                            "<span class='slick-cell l13 r13'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M6Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l14 r14'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Pieces + "</span></span>" +
                            "<span class='slick-cell l15 r15'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M7Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l16 r16'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Pieces + "</span></span>" +
                            "<span class='slick-cell l17 r17'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M8Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l18 r18'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Pieces + "</span></span>" +
                            "<span class='slick-cell l19 r19'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M9Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l20 r20'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Pieces + "</span></span>" +
                            "<span class='slick-cell l21 r21'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M10Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l22 r22'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Pieces + "</span></span>" +
                            "<span class='slick-cell l23 r23'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M11Amount.toFixed(2) + "</span></span>" +
                            "<span class='slick-cell l24 r24'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Pieces + "</span></span>" +
                            "<span class='slick-cell l25 r25'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.M12Amount.toFixed(2) + "</span></span>";
                    },
                getter: 'SubCategoryName',
                displayTotalsRow: false

            }])

            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
      
        onViewProcessData(response: Serenity.ListResponse<POSSalesItemsRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new ProductWiseSalesPanel(this.chartContainer, { items: response.Entities });

            //var options = {
            //    chart: {
            //        type: 'bar'
            //    },
            //    series: [
            //        {
            //            name: 'sales',
            //            data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
            //        }
            //    ],
            //    xaxis: {
            //        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
            //    }
            //}

            //var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            //chart.render();


            return response;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            });
            return buttons;
        }

    }
}